import axios from 'axios';

export const AddressService = (apiUrl) => ({
  getAddressSuggestions: async (value, requestNo) => {
    const defaultResult = {
      suggestions: [],
      requestNo,
    };
    try {
      const { data } = await axios.get(`${apiUrl}?term=${value}`);
      let suggestions;

      if (Array.isArray(data)) {
        suggestions = data.map((e) => ({
          address: e.label,
          id: e.id,
        }));
      }
      let results = Array.isArray(suggestions) ? suggestions : [];

      return {
        ...defaultResult,
        suggestions: results.filter(isRelatedResult),
      };
    } catch (err) {
      return defaultResult;
    }
  },
  getAddressDetailsById: async (id) => {
    const defaultResult = {};
    try {
      const { data, status } = await axios.get(`${apiUrl}/${id}`);
      return status === 200 ? data : defaultResult;
    } catch (err) {
      return defaultResult;
    }
  },
});

const isRelatedResult = (result) => {
  return result.id !== 'UseAddressAsEntered' && result.id !== 'UseAddressAsEntered_NoValue';
};
